<template>
  <div class="col-sm-12 col-md-4 align-self-md-center">
    <a href="#form-modal" data-toggle="modal" @click="getLink(link)">
      <div class="story-card" style="cursor: pointer;">
        <div class="story-card-img">
          <img :src="resolve_img_url(image)" />
        </div>
        <div class="story-card-content">
          <div class="story-card-title">
            <h4>{{ name }}</h4>
          </div>
          <div class="story-card-body">
            <p>{{ description }}</p>
          </div>
          <router-link id="link" style="visibility:hidden;" :to="{path:link}">LINK</router-link>
          <div class="story-card-footer pricing-button">
            <a class="pricing-button-blue">Read Full Story</a>
          </div>
        </div>
      </div>
    </a>
    <div
      class="modal fade"
      id="form-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <h3>Read the Full Case Study</h3>
            <p></p>
            <form
              @submit.prevent="handleFormSubmit"
              class="gform needs-validation"
              method="POST"
              action="https://script.google.com/a/verloop.io/macros/s/AKfycbxDxqOt7ijbtFMmilinAzqOHO5_ll0qaxopwJz8/exec"
            >
              <div class="form-elements">
                <div class="row">
                  <div class="col-md-6">
                    <input
                      id="First_Name"
                      class="form-control"
                      name="First_Name"
                      placeholder="First Name"
                      required
                    />
                  </div>
                  <div class="col-md-6">
                    <input
                      id="Last_Name"
                      class="form-control"
                      name="Last_Name"
                      placeholder="Last Name"
                      required
                    />
                  </div>
                </div>

                <div class="form-group"></div>

                <div class="form-group">
                  <input
                    id="Company_Name"
                    class="form-control"
                    name="Company_Name"
                    placeholder="Company"
                    required
                  />
                </div>

                <div class="form-group">
                  <input
                    id="Work_Email"
                    name="Work_Email"
                    class="form-control"
                    type="email"
                    required
                    placeholder="Work Email"
                  />
                </div>

                <div class="checkbox">
                  <label>
                    <input type="checkbox" value required />I agree to the
                    <router-link to="/terms.html" target="_blank">Terms of Use</router-link>&nbsp;and
                    <router-link to="/privacy.html" target="_blank">Privacy Policy</router-link>
                  </label>
                </div>

                <button class="btn button-xlarge">Read Full Story</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "case-study-brands",
  props: { name: String, image: String, description: String, link: String },
  methods: {
    resolve_img_url: function(path) {
      let images = require.context(
        "../../../assets/images/",
        false,
        /\.png$|\.jpg$/
      );
      return images("./" + path);
    },
    getLink(l) {
      window.localStorage.setItem("link", l);
    },
    handleFormSubmit(event) {
      // handles form submit without any jquery
      event.preventDefault(); // we are submitting via xhr below
      var form = event.target;
      var formData = this.getFormData(form);
      var data = formData.data;
      var email = data.Work_Email;
      if (
        email.includes("@gmail.com") ||
        email.includes("@hotmail.com") ||
        email.includes("@yahoo.com") ||
        email.includes("@outlook.com") ||
        email.includes("@zoho.com") ||
        email.includes("@aol.com") ||
        email.includes("@aim.com") ||
        email.includes("@protonmail.com") ||
        email.includes("@gmx.com") ||
        email.includes("@icloud.com")
      ) {
        alert("Please enter a valid work email");
        return false;
      }
      // If a honeypot field is filled, assume it was done so by a spam bot.
      if (formData.honeypot) {
        return false;
      }

      this.disableAllButtons(form);

      var xhr = new XMLHttpRequest();
      var parent = this;
      xhr.open(
        "POST",
        "https://script.google.com/a/verloop.io/macros/s/AKfycbxDxqOt7ijbtFMmilinAzqOHO5_ll0qaxopwJz8/exec",
        false
      );
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
      xhr.onreadystatechange = function() {
        if (xhr.readyState === 4 && xhr.status === 200) {
          form.reset();
          var formElements = form.querySelector(".form-elements");
          if (formElements) {
            formElements.style.display = "none"; // hide form
          }
          var savedLink = window.localStorage.getItem("link");
          parent.$router.push(savedLink);
          window.$(".modal").click();
          window.localStorage.removeItem("link");
        }
      };
      var encoded = Object.keys(data)
        .map(function(k) {
          return encodeURIComponent(k) + "=" + encodeURIComponent(data[k]);
        })
        .join("&");
      // url encode form data for sending as post data
      xhr.send(encoded);
    },
    getFormData(form) {
      var elements = form.elements;
      var honeypot;
      var fields = Object.keys(elements)
        .filter(function(k) {
          if (elements[k].name === "honeypot") {
            honeypot = elements[k].value;
            return false;
          }
          return true;
        })
        .map(function(k) {
          if (elements[k].name !== undefined) {
            return elements[k].name;
            // special case for Edge's html collection
          } else if (elements[k].length > 0) {
            return elements[k].item(0).name;
          }
        })
        .filter(function(item, pos, self) {
          return self.indexOf(item) == pos && item;
        });
      var formData = {};
      fields.forEach(function(name) {
        var element = elements[name];
        // singular form elements just have one value
        formData[name] = element.value;
        // when our element has multiple items, get their values
        if (element.length) {
          var data = [];
          for (var i = 0; i < element.length; i++) {
            var item = element.item(i);
            if (item.checked || item.selected) {
              data.push(item.value);
            }
          }
          formData[name] = data.join(", ");
        }
      });
      // add form-specific values into the data
      formData.formDataNameOrder = JSON.stringify(fields);
      formData.formGoogleSheetName = form.dataset.sheet || "responses"; // default sheet name
      formData.formGoogleSend = form.dataset.email || ""; // no email by default
      return {
        data: formData,
        honeypot: honeypot
      };
    },
    loaded() {
      // bind to the submit event of our form
      var forms = document.querySelectorAll("form.gform");
      for (var i = 0; i < forms.length; i++) {
        forms[i].addEventListener("submit", this.handleFormSubmit, false);
      }
    },
    disableAllButtons(form) {
      var buttons = form.querySelectorAll("button");
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].disabled = true;
      }
    }
  }
};
</script>
<style scoped lang="scss">
.modal-body {
  padding: 60px;
}
h2,
h3,
h4,
p,
a {
  overflow-y: hidden;
  text-decoration: none;
}
a:hover {
  text-decoration: none;
}

.modal-body {
  // padding: 50px !important;
  -webkit-overflow-scrolling: touch;
}
.modal-dialog {
  position: relative;
  display: table;
  border-radius: 20px;
  /* This is important */
  overflow-y: auto;
  overflow-x: auto;
  width: auto;
  min-width: 300px;
}
.btn-danger {
  background-color: #ee6387;
}
.modal-lg {
  width: flex !important;
}
.modal {
  text-align: center;
}
@media screen and (min-width: 768px) {
  .modal:before {
    display: inline-block;
    vertical-align: middle;
    content: " ";
    height: 100%;
  }
}
@media (max-width: 767px) {
  #content .modal.fade.in {
    top: 5%;
  }
  .modal {
    position: fixed;
    top: 10%;
    right: 3%;
    left: 3%;
    width: auto;
    margin: 0;
  }
  .modal-body img {
    width: 100%;
  }
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}
.btn {
  padding: 6px 35px;
  background-color: #ff7a59;
  color: #fff;
}
</style>
